import { instance } from './config';

export const getPaymentStatus = () => {
   return instance.get('/payment-status', {});
};
